import createModule from "../createModule"
import { Creators as DialogCreators } from "modules/dialog/model"
import view from "./view"
import { times, get } from "lodash"
import { getPositionSet } from "helpers/comparison"
import { Creators } from "./model"
import { getComparisonItems } from "./selectors"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: props.account,
    modelId: props.modelId,
    comparisonItems: props.comparisonItems,
    startDate: props.startDate,
    endDate: props.endDate,
    currency: props.currency,
  }),
  required: ["account", "modelId", "comparisonItems", "startDate", "endDate"],
  data: [...times(5, (n) => {
    return {
      resource: `longShortData${n}`,
      as: null,
      url: ({ modelId, comparisonItems, startDate, endDate, currency }) => {
        if (!comparisonItems || !comparisonItems[n]) {
          return null
        }
        const positionSet = getPositionSet(comparisonItems, n, startDate, { composition: true, currency })

        return {
          id: `longShort-${modelId}-${get(comparisonItems[n], "id", n)}-${startDate}-${endDate}-${JSON.stringify(positionSet)}`,
          query: `query ($modelId: String!, $positionSet: PositionSetInput!, $date: Date!) {
              model (id: $modelId) {
                simulation (positionSet: $positionSet, from: $date, to: $date) {
                  composition {
                    date
                    longShortComposition: compositionBy(groupBy: LONG_SHORT) {
                      id
                    }
                  }
                }
              }
            }`,
          variables: {
            modelId,
            positionSet,
            date: endDate,
          },
        }
      },
    }
  })],
  mapStateToProps: (state, props) => ({
    newItems: getComparisonItems(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
})
